import AssetContentMode from "../enum/AssetContentMode";
import AssetType from "../enum/AssetType";
import UploadType from "../enum/UploadType";

export function getAssetContentModeCss(contentMode: AssetContentMode, fullCss: boolean = false): string|null {

    switch (contentMode) {

        case AssetContentMode.COVER:
            return fullCss ? "background-size: cover" : "cover";

        case AssetContentMode.CONTAIN:
            return fullCss ? "background-size: contain" : "contain";

        default:
            return null;
    }
}

export function getAssetTypeFromUploadType(uploadType: UploadType): AssetType|null {

    switch (uploadType) {

        case UploadType.ASSET_IMAGE:
            return AssetType.IMAGE;

        case UploadType.ASSET_VIDEO:
            return AssetType.VIDEO;

        case UploadType.ASSET_FONT:
            return AssetType.FONT;

        default:
            return null;
    }
}

export function getAssetsFromSlide(slide, getAsset) {

    if (slide == null) {
        return [];
    }

    return (
        [
            ...slide.widgets.map(w => w.style?.backgroundAssetId),
            ...slide.widgets.map(w => w.settings?.assetId)
        ]
        .filter(id => id != null)
        .map(id => getAsset(id))
        .filter(itm => !!itm)
    );
}

export function getAssetsFromShow(show, getAsset) {

    return show?.slides?.map(

        s => getAssetsFromSlide(s, getAsset)
    )
    .flat()
}